export default "__VITE_ASSET__1fafcb1c__"